import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { Route, Routes as RouterRoutes, Navigate, useLocation, useSearchParams } from 'react-router-dom'
import Login from '../components/Login'
import App from '../App'
import checkLogin from '../utils/userLogin'
import { LOGIN } from '../thunks/login/reduers'
import { fetchMeData } from '../thunks/me/actions'
import ExamPage from '../pages/ExamPage'
import ResultPage from '../pages/ResultPage'
import QuestionReviewPage from '../pages/QuestionReviewPage'
import StartPage from '../pages/StartPage'
import ProtectedRoutes from './ProtectedRoutes'
import { getRedirectParams, saveRedirectParams } from '../utils/urlUtils'
import { handleAuthFlow } from '../utils/authUtils'

const Routes = () => {
  const { loggedIn } =  useSelector((state) => state.login)
  const meState = useSelector((state) => state.me)
  const dispatch = useDispatch()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  
  useEffect(() => {
    // Check for redirect parameters in URL
    const redirectParams = getRedirectParams();
    const urlTestId = searchParams.get('test');
    
    // If test parameter exists in URL, save it
    if (urlTestId || redirectParams.test || redirectParams.testseries) {
      const paramsToSave = {
        ...redirectParams,
        test: urlTestId || redirectParams.test
      };
      saveRedirectParams(paramsToSave);
    }
    
    // Handle authentication flow
    if (checkLogin()) {
      dispatch({ type: LOGIN.LOGGED_IN })
      
      // Fetch user data if not already loaded
      if (!meState.fetched || !meState.data || Object.keys(meState.data).length === 0) {
        dispatch(fetchMeData((userData, userError) => {
          if (!userError) {
            console.log('User data loaded on app start:', userData);
          } else {
            console.error('Error loading user data on app start:', userError);
          }
        }));
      }
    }
  }, [dispatch, location, searchParams, meState.fetched, meState.data])

  return (
    <App>
      <RouterRoutes>
        <Route path="/login" element={!loggedIn ? <Login /> : <Navigate to="/start" replace />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<Navigate to="/start" replace />} />
          <Route path="/start" element={<StartPage />} />
          <Route path="/exam" element={<ExamPage />} />
          <Route path="/result" element={<ResultPage />} />
          <Route path="/question-review" element={<QuestionReviewPage />} />
        </Route>
        <Route path="*" element={!loggedIn ? <Navigate to="/login" replace /> : <Navigate to="/start" replace />} />
      </RouterRoutes>
     </App>
  )
}

export default Routes
